import React, { useRef } from "react";
import "./default-modal.scss";
import Modal from "react-modal";
import CloseModal from "../mui/close_modal/CloseModal";
import ShowContainer from "../mui/ShowContainer";
import ErrorBoundary from "../mui/error_boundary/ErrorBoundary";
import { useAppSelector } from "../../store/index.ts";
import useScrollUpOnKeyboardClose from "../../hooks/Usescrolluponkeyboardclose.js";

export default function DefaultModal({
  isOpen,
  closeModal,
  classModal = "",
  children,
  hideClose,
  miniModal,
  overlayClassName,
  bigModal,
  largeModal,
  isFull
}) {
  const lang = useAppSelector((state) => state.common.lang);
  const contentRef = useRef(null);

  useScrollUpOnKeyboardClose(isOpen, contentRef);

  const modalClass = isFull
    ? "full"
    : largeModal
      ? "large"
      : bigModal
        ? "big"
        : miniModal
          ? "mini"
          : "";

  return (
    <Modal
      ariaHideApp={false}
      className={`default-modal ${modalClass}  ${classModal} ${lang}`}
      isOpen={isOpen}
      onRequestClose={closeModal}
      overlayClassName={overlayClassName}
      shouldFocusAfterRender={false}
      contentRef={(node) => (contentRef.current = node)}>
      <ShowContainer condition={!hideClose}>
        <CloseModal close={closeModal} />
      </ShowContainer>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Modal>
  );
}
